import type { JSX, ReactNode, TransitionEventHandler } from 'react'

import { clsx } from 'clsx'

import { Flex } from '@buffer-mono/popcorn'

import styles from '~publish/legacy/composer/composer/components/app/LegacyComposer.module.css'

export function ComposerSectionsColumn({
  sidePanelOpen,
  className,
  onTransitionEnd,
  children,
}: {
  sidePanelOpen: boolean
  className?: string
  onTransitionEnd?: TransitionEventHandler<HTMLElement>
  children: ReactNode
}): JSX.Element {
  return (
    <Flex
      as="section"
      direction="column"
      align="stretch"
      data-side-panel={sidePanelOpen ? 'open' : 'closed'}
      className={clsx(styles.composerSectionsWrapper, className)}
      onTransitionEnd={onTransitionEnd}
    >
      {children}
    </Flex>
  )
}
